/**
 * 错误监控相关类型定义
 */

// 错误类型枚举
export enum ErrorType {
  JAVASCRIPT = "javascript", // JS运行错误
  RESOURCE = "resource", // 资源加载错误
  REQUEST = "request", // 接口请求错误
  VUE = "vue" // Vue组件错误
}

// 基础错误报告接口
export interface BaseErrorReport {
  error_type: ErrorType;
  message: string;
  error_url: string;
  timestamp: number;
  userAgent: string;
  environment: string;
}

// JavaScript错误报告
export interface JavaScriptErrorReport extends BaseErrorReport {
  error_type: ErrorType.JAVASCRIPT;
  stack?: string;
  filename?: string;
  lineno?: number;
  colno?: number;
}

// 资源加载错误报告
export interface ResourceErrorReport extends BaseErrorReport {
  error_type: ErrorType.RESOURCE;
  resource_type: string;
  resource_url: string;
  is_critical?: boolean; // 是否为关键资源
}

// 接口请求错误报告
export interface RequestErrorReport extends BaseErrorReport {
  error_type: ErrorType.REQUEST;
  status?: number;
  response?: string;
  request_url: string;
  method?: string;
}

// Vue组件错误报告
export interface VueErrorReport extends BaseErrorReport {
  error_type: ErrorType.VUE;
  component_name?: string;
  stack?: string;
}

// 联合类型
export type ErrorReport = JavaScriptErrorReport | ResourceErrorReport | RequestErrorReport | VueErrorReport;

// 错误监控配置
export interface ErrorMonitorConfig {
  enableInDev: boolean; // 是否在开发环境启用
  enableInTest: boolean; // 是否在测试环境启用
  enableInPre: boolean; // 是否在预发布环境启用
  enableInProd: boolean; // 是否在生产环境启用
  maxErrors: number; // 最大错误数量限制
  throttleTime: number; // 错误节流时间(ms)
}
